import { render, staticRenderFns } from "./StuNumToYouthStatisticsWomen.vue?vue&type=template&id=28630cbf&scoped=true&"
import script from "./StuNumToYouthStatisticsWomen.vue?vue&type=script&lang=js&"
export * from "./StuNumToYouthStatisticsWomen.vue?vue&type=script&lang=js&"
import style0 from "./StuNumToYouthStatisticsWomen.vue?vue&type=style&index=0&id=28630cbf&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28630cbf",
  null
  
)

export default component.exports